import { clsx, type ClassValue } from 'clsx';
import { format, parseISO } from 'date-fns';
import { twMerge } from 'tailwind-merge';

/**
 * Safely merges Tailwind classes, preventing conflicts when injecting
 * dynamic conditional colors (e.g., swapping text-rose-500 for text-emerald-500).
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/** Formats basis points with explicit +/- signs and 1 decimal place. */
export function formatBps(value: number | null | undefined): string {
    if (value == null) return '--';
    const prefix = value > 0 ? '+' : '';
    return `${prefix}${value.toFixed(1)} bps`;
}

/** Formats standard yield rates (e.g., 5.253%). */
export function formatYield(value: number | null | undefined): string {
    if (value == null) return '--';
    return `${value.toFixed(3)}%`;
}

/** Safely formats the ISO date string from the backend. */
export function formatDate(dateString: string | null | undefined): string {
    if (!dateString) return '--';
    try {
        return format(parseISO(dateString), 'MMM d, yyyy');
    } catch {
        return dateString; // Fallback for unparseable input.
    }
}
